import { verifyUserEmail } from "@/services/passport/passport.service"
import { useRequest } from "ahooks"
import { Alert, Button, Form } from "antd"
import { useEffect, useState } from "react"
import { useMatch, useNavigate } from "react-router"
import { VerifyEmail } from "../Login/VerifyEmail"


export function Activation() {
  const navigate = useNavigate()
  const [form] = Form.useForm()
  const matches = useMatch('/entrance/activation/:token')
  const [success, setSuccess] = useState<boolean>()
  const {data, run: toVerify} = useRequest((token) => verifyUserEmail(token), {
    manual: true,
    onSuccess: () => setSuccess(true),
    onError: () => {
    setSuccess(false)
  }})

  useEffect(() => {
    if (matches?.params.token) {
      toVerify(matches?.params.token)
    }
  }, [matches])

  const toLogin = () => {
    navigate('/login')
  }

  const email = data?.email

  return <div>
    {success && <div>
      <div>The account <span style={{fontWeight: 'bold'}}>{email} </span> was successfully activated.</div>
      <div className="flex-center">
        <Button onClick={toLogin} style={{width: '80%'}} type="primary" className="mt-2 full-width">To Login</Button>
      </div>
    </div>}
    {success === false && <div>
      <Alert message="The activation link has expired. Please try again." type="error" />
      <VerifyEmail />
    </div>}
  </div>
}